export default __webpack_public_path__ + "static/media/start-date-confirmed.3bb9c840.png";